module.exports = __webpack_public_path__ + "static/media/anon.df6f9b93.jpg";